module.exports = __webpack_public_path__ + "img/632.problem_lightning.b8ed803b.svg";